import { RowDispatchCheckpointDto } from "@/dtos";
import { DispatchCheckpoint, SanctionItem } from "@/entities";
import { TripPatternOrientation } from "@/helpers/types";
import { addTimeToDateTime, parseToLocalDateTimeFromUtc, parseToTimeFromSeconds } from "@/helpers/utilities";
import { MapCheckpoint } from "@/ui/components/maps/common/interfaces/map-checkpoint";
import { MapLine } from "@/ui/components/maps/common/interfaces/map-line";

export const formatSanctionTotal = (sanctions: SanctionItem[]) => {
    if (sanctions.length > 0) {
        let result = 0;

        sanctions.map(x => {
            if (x.sanction.scales) {
                x.sanction.scales.map(y => {
                    result += parseFloat(y.sanction)
                });
            } else {
                result += parseFloat(x.sanction.sanction as string);
            }
        });

        return result.toFixed(2);
    }

    return '0.00';
}

const getTimesShouldArrive = (dispatchCheckpoints: DispatchCheckpoint[]) => {
    if (dispatchCheckpoints.length > 0) {
        let dateTime: string = dispatchCheckpoints[0].dispatch.date_start.toString();
        return dispatchCheckpoints.map((x, i) => {
            if (i == 0) {
                return {
                    checkpoint_id: x.checkpoint_id,
                    date_should_arrive: parseToLocalDateTimeFromUtc(dispatchCheckpoints[0].dispatch.date_start.toString())
                };
            }

            const amount = x.time_between_checkpoints;
            dateTime = addTimeToDateTime(dateTime, amount, 'seconds');

            return {
                checkpoint_id: x.checkpoint_id,
                date_should_arrive: parseToLocalDateTimeFromUtc(dateTime)
            };
        });
    }

    return [];
}

export const formatRowDispatchCheckpointDto = (dispatchCheckpoints: DispatchCheckpoint[]) => {
    const timesShouldArrive = getTimesShouldArrive(dispatchCheckpoints);

    return dispatchCheckpoints.map(x => {
        const row: RowDispatchCheckpointDto = {
            ...x,
            checkpoint: x.data_checkpoint.checkpoint.name,
            time_between_checkpoints_label: parseToTimeFromSeconds(x.time_between_checkpoints),
            time_should_arrived_label: (x.date_should_arrived) ?
                parseToLocalDateTimeFromUtc(x.date_should_arrived.toString()) :
                timesShouldArrive.find(y => y.checkpoint_id == x.checkpoint_id)?.date_should_arrive ?? '',
            time_arrived_label: (x.date_arrived) ? parseToLocalDateTimeFromUtc(x.date_arrived.toString()) : '',
            time_difference_label: (x.time_difference) ? parseToTimeFromSeconds(Math.abs(x.time_difference)) : '',
            sanction_label: (x.data_checkpoint.is_sanctionable) ? 'Sancionable' : 'No Sancionable',
            sanction_total: `$ ${formatSanctionTotal(x.sanction)}`
        }

        return row;
    });
}

export const formatDispatchCheckpointMap = (dispatchCheckpoints: DispatchCheckpoint[]): MapLine => {
    if (dispatchCheckpoints.length > 0) {
        const coords = dispatchCheckpoints.map((x, i) => {
            const coord: MapCheckpoint = {
                name: x.data_checkpoint.checkpoint.name,
                coordinate: [x.data_checkpoint.checkpoint.longitude, x.data_checkpoint.checkpoint.latitude],
                isPrimaryColor: true,
                radio: x.data_checkpoint.checkpoint.radio
            }
            return coord;
        });

        const dispatchCheckpoint = dispatchCheckpoints[0];
        const name = (dispatchCheckpoint.data_checkpoint.type == TripPatternOrientation.OUTBOUND) ? 'outbound' : 'inbound';
        const mapLine: MapLine = {
            identification: name,
            coordinates: coords
        }

        return mapLine;
    }

    return {} as MapLine;
}